/**
 * Creates an interval using requestAnimationFrame for better performance
 * compared to setTimeout, especially when the tab is not active
 *
 * @param callback Function to call on each interval
 * @param delay Delay in milliseconds between calls
 * @returns Function to abort/cancel the interval
 */
export const requestAnimationFrameInterval = (
  callback: () => void,
  delay: number,
): (() => void) => {
  let start = Date.now();
  let handle: number | null = null;

  const loop = () => {
    const current = Date.now();
    if (current - start >= delay) {
      callback();
      start = Date.now();
    }
    handle = requestAnimationFrame(loop);
  };

  handle = requestAnimationFrame(loop);

  return () => {
    if (handle !== null) {
      cancelAnimationFrame(handle);
      handle = null;
    }
  };
};
